import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Field, inputCls, LegalFooter } from './shared';

export const VisitationForm = ({ country }) => {
  const { api } = useAuth();
  const [f, setF] = useState({ ages: '', custody: 'exclusivo', distance_km: 10, conflict_level: 'bajo' });
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const ages = f.ages.split(',').map((a) => a.trim()).filter(Boolean).map(Number).filter((n) => !Number.isNaN(n));
    if (!ages.length) return toast.error('Ingresa la edad de al menos un hijo');
    setLoading(true);
    try {
      const { data } = await api.post('/family/visitation', { country, children_ages: ages, custody: f.custody, distance_km: Number(f.distance_km), conflict_level: f.conflict_level });
      setRes(data);
    } catch (err) {
      setRes(null);
      toast.error(err.response?.data?.detail || 'No se pudo generar la propuesta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <form onSubmit={submit} className="space-y-4" data-testid="visitation-form">
        <Field label="Edades de los hijos" hint="Separadas por coma, ej: 4, 10">
          <input data-testid="vis-ages" value={f.ages} onChange={set('ages')} placeholder="4, 10" className={inputCls} />
        </Field>
        <Field label="Tipo de cuidado personal">
          <select data-testid="vis-custody" value={f.custody} onChange={set('custody')} className={inputCls}>
            <option value="exclusivo">Exclusivo de un progenitor</option>
            <option value="compartido">Compartido</option>
          </select>
        </Field>
        <Field label="Distancia entre hogares (km)">
          <input data-testid="vis-distance" type="number" min="0" value={f.distance_km} onChange={set('distance_km')} className={inputCls} />
        </Field>
        <Field label="Nivel de conflicto entre los padres">
          <select data-testid="vis-conflict" value={f.conflict_level} onChange={set('conflict_level')} className={inputCls}>
            <option value="bajo">Bajo</option>
            <option value="medio">Medio</option>
            <option value="alto">Alto</option>
          </select>
        </Field>
        <button data-testid="vis-submit" disabled={loading} className="inline-flex items-center gap-2 rounded-full bg-rose-500 px-6 py-2.5 text-sm font-semibold text-white hover:bg-rose-400 transition-colors disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Generar propuesta
        </button>
      </form>
      {res && (
        <div data-testid="vis-result" className="space-y-3 rounded-2xl border border-rose-500/30 bg-rose-500/5 p-5">
          {res.plans.map((p, i) => (
            <div key={i} className="rounded-xl border border-slate-800 bg-slate-950/50 p-4 text-sm">
              <p className="font-semibold text-white">Hijo de {p.edad} años · {p.tramo}</p>
              <p className="mt-2 text-slate-300"><span className="text-slate-500">Fines de semana:</span> {p.fines_de_semana}</p>
              <p className="text-slate-300"><span className="text-slate-500">Durante la semana:</span> {p.semana}</p>
              <p className="text-slate-300"><span className="text-slate-500">Vacaciones:</span> {p.vacaciones}</p>
              <p className="mt-1 text-xs text-rose-200">{p.nota}</p>
            </div>
          ))}
          <ul className="list-disc pl-5 text-sm text-slate-300">{res.general_rules.map((r) => <li key={r}>{r}</li>)}</ul>
          <LegalFooter basis={res.legal_basis} disclaimer={res.disclaimer} />
        </div>
      )}
    </div>
  );
};
